import { Component } from '@angular/core';

@Component({
  selector: 'app-verify-information-form',
  templateUrl: './verify-information-form.component.html',
  styleUrls: ['./verify-information-form.component.scss']
})
export class VerifyInformationFormComponent {

}
